import { logger } from 'lib/logger';
import { xray } from 'lib/xray';
import { seriallyClearQuotaCleanerFeature } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleanerSeriallyClear';
import { hideSnackbarAction, showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import {
    reloadGroupAfterDelete,
    setIsItemsDeleteError,
    setIsItemsDeleteProcess,
    setNeedsGroupReload,
} from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { quotaCleanerRlog } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.constants';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import { put } from 'redux-saga/effects';

import { getGroupType } from '../helpers/getGroupType';

export function* deleteItemsError(action: {
    error;
    groupId: UserQuotaGroupId;
    ids: string[];
    itemIds: string[];
    size: number;
    step?: 'trash' | 'remove';
}) {
    const { error, groupId, ids, itemIds, size, step } = action;
    yield put(setIsItemsDeleteProcess({ value: false }));

    logger.error(error);
    xray.send(`quota-cln-delete-err`, {
        rlog: quotaCleanerRlog,
        rlog_message: {
            error,
            groupId,
            ids,
        },
        dwh_enabled: true,
        dwh_enabled_fields: [['step', 'group_id', 'group_type', 'platform']],
        dwh: {
            step,
            group_id: groupId,
            group_type: getGroupType(groupId),
            platform: getPlatformInfo().join('_'),
        },
    });

    if (seriallyClearQuotaCleanerFeature) {
        yield put(hideSnackbarAction('quotaCleanerDeleteAllItems'));
        yield put(
            showSnackbarAction({
                type: SnackbarTypes.failure,
                id: 'quotaCleanerDeleteAllItemsError',
                text: `Не получилось удалить файлы. \nПовторите попытку позже`,
                closable: true,
                wrapText: true,
            })
        );
    } else {
        yield put(
            showSnackbarAction({
                id: 'quotaCleanerDeleteError',
                type: SnackbarTypes.failure,
                closable: true,
                title: 'Ошибка удаления',
                text: 'Попробуйте повторить действие через пару минут.',
            })
        );
    }

    yield put(setNeedsGroupReload({ value: true }));
    yield put(setIsItemsDeleteError({ value: true }));
    yield put(reloadGroupAfterDelete({ ids, groupId, isGroupReset: true, size, itemIds }));
}
